<template>
  <div
    v-if="hasSectionWrapper"
    class="flex cursor-pointer items-center justify-between p-4"
    :data-cy="name"
    :class="{ 'shrink-0': shrinkItems }"
    @click="toggleSection"
  >
    <div
      class="flex space-x-2"
      :class="sectionsContext === 'services' ? 'text-xs' : 'text-xxs'"
    >
      <span
        class="flex h-5 w-5 items-center justify-center rounded-full bg-gray-200 font-semibold text-headline"
      >
        {{ items.length }}
      </span>
      <span
        class="flex items-center text-gray-500"
        :class="
          sectionsContext === 'services'
            ? 'font-semibold capitalize'
            : 'font-medium uppercase'
        "
      >
        {{ name.replaceAll("_", " ") }}
      </span>
    </div>
    <button class="cursor-pointer">
      <icon-base
        :class="{ 'rotate-180 transform': isExpanded }"
        height="6"
        width="10"
        icon="dropdown-arrow"
        :icon-color="UTIL_COLORS.LABEL"
      />
    </button>
  </div>
  <div
    v-show="show"
    class="space-y-4 overflow-y-auto"
    :data-cy="name + '-items'"
    :class="{ items: hasSectionWrapper && !shrinkItems, 'h-full': shrinkItems }"
  >
    <component
      v-for="item in items"
      :is="componentName"
      :key="item.title"
      :model="item"
      :type="name"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { UTIL_COLORS } from "@/helpers/constants";
import { useEmitter } from "@/hooks/common";
import { CLOSE_SIDE_PANEL_SECTIONS } from "@/helpers/constants/events";

const props = defineProps({
  name: {
    type: String,
    default: ""
  },
  componentName: {
    type: String,
    default: ""
  },
  isInitiallyExpanded: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array,
    default: () => []
  },
  shrinkItems: {
    type: Boolean,
    default: false
  },
  sectionsContext: {
    type: String,
    required: true
  }
});

const emitter = useEmitter();
const isExpanded = ref(props.isInitiallyExpanded);
const hasSectionWrapper = computed(() => props.name !== "null");
const show = computed(() => isExpanded.value || !hasSectionWrapper.value);

emitter.on(CLOSE_SIDE_PANEL_SECTIONS, (panelName) => {
  isExpanded.value = !isExpanded.value && panelName === props.name;
});

const toggleSection = () => {
  emitter.emit(CLOSE_SIDE_PANEL_SECTIONS, props.name);
};
</script>
<style scoped>
.items {
  max-height: 38% !important;
}
</style>
